/**
 * Avatar-fallback initials: first letter of up to the first two words of a
 * display name, or the first two characters of an email, or `fallback` when
 * neither is available. Shared by AdminAvatar and ContactCard so the two
 * "person chip" flavors in the kit agree on how initials are derived.
 */
export function computeInitials(name, email, fallback = '??') {
    const trimmedName = name?.trim();
    if (trimmedName) {
        const parts = trimmedName.split(/\s+/).filter(Boolean);
        return parts
            .slice(0, 2)
            .map((p) => p[0].toUpperCase())
            .join('');
    }
    const trimmedEmail = email?.trim();
    if (trimmedEmail)
        return trimmedEmail.slice(0, 2).toUpperCase();
    return fallback;
}
/**
 * Инициалы сущности (страница, Instagram, кабинет): первые буквы первых
 * одного-двух слов, где слово — только буквы и цифры любой письменности.
 * Скобки, `|`, `·`, `@`, подчёркивания — не слова и в инициалы не попадают:
 * «Linda (AURA)» → «LA», «Robert | Professional Astrologer» → «RP». Ни
 * одного слова — `fallback`.
 */
export function entityInitials(name, fallback = '?') {
    const words = name?.match(/[\p{L}\p{N}]+/gu) ?? [];
    if (words.length === 0)
        return fallback;
    return words
        .slice(0, 2)
        .map((w) => (Array.from(w)[0] ?? '').toLocaleUpperCase())
        .join('');
}
//# sourceMappingURL=initials.js.map